export class ApiError extends Error {
  status: number;
  details?: unknown;
  constructor(message: string, status: number, details?: unknown) {
    super(message);
    this.status = status;
    this.details = details;
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`/api${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers
    }
  });
  const contentType = response.headers.get('content-type') || '';
  const body = contentType.includes('application/json') ? await response.json() : await response.text();
  if (!response.ok) {
    const message = typeof body === 'object' && body?.error ? body.error : `Request failed (${response.status})`;
    throw new ApiError(message, response.status, typeof body === 'object' ? body.details : undefined);
  }
  return body as T;
}

let activeCurrencyCode = 'PKR';

export const setCurrencyCode = (value: string | null | undefined) => {
  const normalized = value?.trim().toUpperCase();
  activeCurrencyCode = normalized || 'PKR';
};

export const money = (value: string | number | null | undefined) =>
  `${activeCurrencyCode} ${new Intl.NumberFormat('en-PK', { maximumFractionDigits: 0 }).format(Number(value || 0))}`;

export const shortDate = (value: string | undefined) => value
  ? new Intl.DateTimeFormat('en-PK', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(value))
  : '—';

export const today = () => new Date().toISOString().slice(0, 10);
export const currentPeriod = () => new Date().toISOString().slice(0, 7);
export const periodEnd = (period: string) => {
  const [year, month] = period.split('-').map(Number);
  return new Date(Date.UTC(year, month, 0)).toISOString().slice(0, 10);
};
